import React, { useCallback, useEffect, useMemo } from "react";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import config from "../../../config/config";
import axios from "axios";
import moment from "moment";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';

import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import Select from "react-select";
import { Box, Stack } from "@mui/material";

export const ChartOfAccountReport = () => {
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const token = localStorage.getItem("Token");
  const locationid = localStorage.getItem("Location");
  const { id } = useParams();
  const navigate = useNavigate();
  const [beginningDate, setBeginningDate] = useState("");
  const [finalDate, setFinalDate] = useState("");
  const [customeDate, setCustomDate] = useState(0);
  const [accountID, setAccountID] = useState(0);
  const [chartOfAccountDropdown, setChartOfAccountDropdown] = useState([]);
  const [amount, setAmount] = useState(0);
  const [selectedAccount, setSelectedAccount] = useState("");

  const dateOptions = [
    { label: "All", value: 0 },
    { label: "Today", value: 1 },
    { label: "This Week", value: 4 },
    { label: "This Month", value: 3 },
    { label: "Last Month", value: 6 },
    { label: "This Year", value: 5 },
    { label: "Last Year", value: 2 },
    { label: "Custom", value: 7 },
  ];

  //Today
  let today = moment().format("YYYY-MM-DD");
  //Week
  const startOfWeek = moment().startOf("week").format("YYYY-MM-DD");
  const endOfWeek = moment().endOf("week").format("YYYY-MM-DD");
  //This Month
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  //Last Month
  const startOfLastMonth = moment()
    .subtract(1, "month")
    .startOf("month")
    .format("YYYY-MM-DD");
  const endOfLastMonth = moment()
    .subtract(1, "month")
    .endOf("month")
    .format("YYYY-MM-DD");
  //This Year
  const startOfYear = moment().startOf("year").format("YYYY-MM-DD");
  const endOfYear = moment().endOf("year").format("YYYY-MM-DD");
  //Last Year
  const startOfLastYear = moment()
    .subtract(1, "year")
    .startOf("year")
    .format("YYYY-MM-DD");
  const endOfLastYear = moment()
    .subtract(1, "year")
    .endOf("year")
    .format("YYYY-MM-DD");

  const handleDateFilter = (event) => {
    // console.log(event, "eventtt");
    setCustomDate(event?.value);
    if (event?.value == 1) {
      setBeginningDate(today);
      setFinalDate(today);
    } else if (event?.value == 4) {
      setBeginningDate(startOfWeek);
      setFinalDate(endOfWeek);
    } else if (event?.value == 3) {
      setBeginningDate(startOfMonth);
      setFinalDate(endOfMonth);
    } else if (event?.value == 6) {
      setBeginningDate(startOfLastMonth);
      setFinalDate(endOfLastMonth);
    } else if (event?.value == 5) {
      setBeginningDate(startOfYear);
      setFinalDate(endOfYear);
    } else if (event?.value == 2) {
      setBeginningDate(startOfLastYear);
      setFinalDate(endOfLastYear);
    } else if (event?.value == 7) {
      setBeginningDate(beginningDate);
      setFinalDate(finalDate);
    } else if (event?.value == null) {
      setBeginningDate("");
      setFinalDate("");
    } else {
      setBeginningDate("");
      setFinalDate("");
    }
  };

  //Date
  const handleDate = (event) => {
    // console.log(event?.target?.value, "eventisss92");
    setBeginningDate(event?.target?.value);
    setCustomDate(7);
  };

  const handleEndDate = (event) => {
    setFinalDate(event?.target?.value);
    setCustomDate(7);
  };

  const descRowsData = responseData?.sort((a, b) => {
    return b?.row_num - a?.row_num;
  });

  const handleEdit = (value, id, isExpanse, RecSaleID) => {
    console.log(value, id, isExpanse, RecSaleID, "handelEdit");
    // return
    if (isExpanse === "Expense") {
      navigate(`/Expense/${RecSaleID}`);
    }

    if (value == 8 || value == 9) {
      navigate(`/manage-sales/${id}`);
    }

    if (value == 6) {
      navigate(`/Expense/${RecSaleID}`);
    }
    if (value == 5) {
      navigate(`/manage-receiving/${RecSaleID}`);
    }
    if (value == 3) {
      navigate(`/manage-receiving/${id}`);
    }

    if (value == 7) {
      navigate(`/receiving-paybills/${id}`);
    }

    if (value == 11) {
      navigate(`/receive-payment/${id}`);
    }

    if (value == 12) {
      navigate(`/bank-deposit/${id}`);
    }

    if (value == 13) {
      navigate(`/manage-transfer/${id}`);
    }

    if (value == 14) {
      navigate(`/journal-entry/${id}`);
    }
  };

  let accountTypeDropdownOption = [];
  const AccountDropdown = chartOfAccountDropdown?.map((u, i) => {
    accountTypeDropdownOption[i] = {
      label: u.Name,
      value: u.ID,
      amount: u.Amount,
      QuickbookId: u.QuickbookId,
    };
  });

  let columnsDefaultShow = {
    AP: false,
    AR: false,
    Deposit: false,
    Payment: false,
    CreatedModifiedDate: false,
    Payee: false,
    Date: true,
    Type: true,
    ID: true,
    Name: true,
    Memo: true,
    ChartOfAccount: true,
    AmountLine: true,
    Balance: true,
    DueDate: true,
  };

  let columns;

  if (id == 1) {
    columns = [
      {
        header: "DATE",
        accessorKey: "Date",
        Cell: ({ row }) =>
          moment(row.original.Date).format("MM/DD/YYYY "),
        size: 100,
      },
      {
        header: "REF NO.",
        accessorKey: "RefNo",
        size: 110,
      },
      {
        header: "TYPE",
        accessorKey: "Type",
        size: 130,
      },
      {
        header: "PAYEE",
        accessorKey: "Payee",
        Cell: ({ row }) =>
          row.original.PayeeUserType === "Customer"
            ? row.original.Payee + " (Cus)"
            : row.original.PayeeUserType === "Supplier"
            ? row.original.Payee + " (Sup)"
            : row.original.PayeeUserType === "Employee"
            ? row.original.Payee + " (Emp)"
            : "",
        // size: 200,
      },
      {
        header: "MEMO",
        accessorKey: "Memo",
        size: 100,
      },
      {
        header: "CHARGE/CREDIT",
        accessorKey: "Payment",
        size: 130,
      },
      {
        header: "PAYMENT",
        accessorKey: "Deposit",
        size: 120,
      },
      {
        header: "DUE DATE",
        accessorKey: "DueDate",
        Cell: ({ row }) =>
          row.original.DueDate
            ? moment(row.original.DueDate).format("MM/DD/YYYY ")
            : "",
        size: 120,
      },
      {
        header: "OPEN BALANCE",
        accessorKey: "Balance",
        // size: 100,
      },
      // {
      //   header: "NUM",
      //   accessorKey: "ID",
      //   Cell: ({ row }) => {
      //     return (
      //       <p
      //         onClick={() =>
      //           handleEdit(
      //             row.original?.TransactionTypeID,
      //             row.original?.ID,
      //             row.original?.Type,
      //             row.original?.RecSaleID
      //           )
      //         }
      //         className="cursor-pointer"
      //       >
      //         {row.original.ID}
      //       </p>
      //     );
      //   },

      //   // size: 100,
      // },
      // {
      //   header: "NAME",
      //   accessorKey: "Name",
      //   // size: 100,
      // },

      // {
      //   header: "ACCOUNT",
      //   accessorKey: "ChartOfAccount",
      //   // size: 100,
      // },
      // // {
      // //   header: "Cleared",
      // //   accessorKey: "ID",
      // //   // size: 100,
      // // },
      // {
      //   header: "AMOUNT",
      //   accessorKey: "AmountLine",
      //   // Cell: ({ row }) => row.original.Deposit > 0 ? row.original.Deposit : row.original.Payment,
      //   // Cell: ({ row }) => {
      //   //   if (row.original.Type === "Receive Payment" ) {
      //   //     return row.original.Deposit;
      //   //   } else if (row.original.Type === "Expense" || row.original.Type === "Vendor Credit" || row.original.Type === "Bill Payment") {
      //   //     return row.original.Payment;
      //   //   } else if ( row.original.Type === "Journal") {
      //   //     return ''
      //   //   } else {
      //   //     return ""; // or some default value
      //   //   }
      //   // },
      //   Cell: ({ row }) => {
      //     const { Type, Deposit, Payment, TransactionTypeID, ID, RecSaleID } =
      //       row.original;
      //     const handleClick = () =>
      //       handleEdit(TransactionTypeID, ID, Type, RecSaleID);
      //     let displayValue = "";

      //     if (Type === "Receive Payment") {
      //       displayValue = Deposit;
      //     } else if (
      //       ["Expense", "Vendor Credit", "Bill Payment"].includes(Type)
      //     ) {
      //       displayValue = Payment;
      //     }

      //     return (
      //       <span onClick={handleClick} className="cursor-pointer">
      //         {displayValue}
      //       </span>
      //     );
      //   },
      //   // size: 100,
      // },

      // {
      //   header: "A/P Paid",
      //   accessorKey: "AP",
      //   // size: 100,
      // },
      // {
      //   header: "A/R Paid",
      //   accessorKey: "AR",
      //   // Cell: ({ row }) => row.original.PayeeUserType === "Customer" ? row.original.Payee : '',
      //   // size: 100,
      // },

      // // {
      // //   header: "Invoiced Date",
      // //   accessorKey: "ID",
      // //   // size: 100,
      // // },
      // {
      //   header: "Last modified Date Line",
      //   accessorKey: "CreatedModifiedDate",
      //   Cell: ({ row }) =>
      //     row.original.CreatedModifiedDate
      //       ? moment(row.original.CreatedModifiedDate).format("YYYY-MM-DD")
      //       : "",
      //   // size: 100,
      // },

      // {
      //   header: "Vendor",
      //   accessorKey: "Payee",
      //   Cell: ({ row }) =>
      //     row.original.PayeeUserType === "Supplier" ? row.original.Payee : "",
      //   // size: 100,
      // },
      // {
      //   header: "Employee",
      //   accessorKey: "Payee",
      //   Cell: ({ row }) =>
      //     row.original.PayeeUserType === "Employee" ? row.original.Payee : "",
      //   // size: 100,
      // },
    ];
  } else if(id == 5){
    columns = [
      {
        header: "DATE",
        accessorKey: "Date",
        Cell: ({ row }) =>
          moment(row.original.Date).format("MM/DD/YYYY "),
        size: 100,
      },
      {
        header: "REF NO.",
        accessorKey: "RefNo",
        size: 110,
      },
      {
        header: "TYPE",
        accessorKey: "Type",
        size: 130,
      },
      {
        header: "PAYEE",
        accessorKey: "Payee",
        Cell: ({ row }) =>
          row.original.PayeeUserType === "Customer"
            ? row.original.Payee + " (Cus)"
            : row.original.PayeeUserType === "Supplier"
            ? row.original.Payee + " (Sup)"
            : row.original.PayeeUserType === "Employee"
            ? row.original.Payee + " (Emp)"
            : "",
        // size: 100,
      },
      {
      header: "ACCOUNT",
      accessorKey: "ChartOfAccount",
      // size: 100,
    },
      {
        header: "MEMO",
        accessorKey: "Memo",
        size: 100,
      },
      {
        header: "DUE DATE",
        accessorKey: "DueDate",
        Cell: ({ row }) =>
          row.original.DueDate
            ? moment(row.original.DueDate).format("MM/DD/YYYY ")
            : "",
        size: 120,
      }, 
      {
        header: "BILLED",
        accessorKey: "Deposit",
        size: 130,
      },
      {
        header: "PAID",
        accessorKey: "Payment",
        size: 120,
      },
      {
        header: "OPEN BALANCE",
        accessorKey: "Balance",
        // size: 100,
      },
      // {
      //   header: "NUM",
      //   accessorKey: "ID",
      //   Cell: ({ row }) => {
      //     return (
      //       <p
      //         onClick={() =>
      //           handleEdit(
      //             row.original?.TransactionTypeID,
      //             row.original?.ID,
      //             row.original?.Type,
      //             row.original?.RecSaleID
      //           )
      //         }
      //         className="cursor-pointer"
      //       >
      //         {row.original.ID}
      //       </p>
      //     );
      //   },

      //   // size: 100,
      // },
      // {
      //   header: "NAME",
      //   accessorKey: "Name",
      //   // size: 100,
      // },

      // {
      //   header: "ACCOUNT",
      //   accessorKey: "ChartOfAccount",
      //   // size: 100,
      // },
      // // {
      // //   header: "Cleared",
      // //   accessorKey: "ID",
      // //   // size: 100,
      // // },
      // {
      //   header: "AMOUNT",
      //   accessorKey: "AmountLine",
      //   // Cell: ({ row }) => row.original.Deposit > 0 ? row.original.Deposit : row.original.Payment,
      //   // Cell: ({ row }) => {
      //   //   if (row.original.Type === "Receive Payment" ) {
      //   //     return row.original.Deposit;
      //   //   } else if (row.original.Type === "Expense" || row.original.Type === "Vendor Credit" || row.original.Type === "Bill Payment") {
      //   //     return row.original.Payment;
      //   //   } else if ( row.original.Type === "Journal") {
      //   //     return ''
      //   //   } else {
      //   //     return ""; // or some default value
      //   //   }
      //   // },
      //   Cell: ({ row }) => {
      //     const { Type, Deposit, Payment, TransactionTypeID, ID, RecSaleID } =
      //       row.original;
      //     const handleClick = () =>
      //       handleEdit(TransactionTypeID, ID, Type, RecSaleID);
      //     let displayValue = "";

      //     if (Type === "Receive Payment") {
      //       displayValue = Deposit;
      //     } else if (
      //       ["Expense", "Vendor Credit", "Bill Payment"].includes(Type)
      //     ) {
      //       displayValue = Payment;
      //     }

      //     return (
      //       <span onClick={handleClick} className="cursor-pointer">
      //         {displayValue}
      //       </span>
      //     );
      //   },
      //   // size: 100,
      // },

      // {
      //   header: "A/P Paid",
      //   accessorKey: "AP",
      //   // size: 100,
      // },
      // {
      //   header: "A/R Paid",
      //   accessorKey: "AR",
      //   // Cell: ({ row }) => row.original.PayeeUserType === "Customer" ? row.original.Payee : '',
      //   // size: 100,
      // },

      // // {
      // //   header: "Invoiced Date",
      // //   accessorKey: "ID",
      // //   // size: 100,
      // // },
      // {
      //   header: "Last modified Date Line",
      //   accessorKey: "CreatedModifiedDate",
      //   Cell: ({ row }) =>
      //     row.original.CreatedModifiedDate
      //       ? moment(row.original.CreatedModifiedDate).format("YYYY-MM-DD")
      //       : "",
      //   // size: 100,
      // },

      // {
      //   header: "Vendor",
      //   accessorKey: "Payee",
      //   Cell: ({ row }) =>
      //     row.original.PayeeUserType === "Supplier" ? row.original.Payee : "",
      //   // size: 100,
      // },
      // {
      //   header: "Employee",
      //   accessorKey: "Payee",
      //   Cell: ({ row }) =>
      //     row.original.PayeeUserType === "Employee" ? row.original.Payee : "",
      //   // size: 100,
      // },
    ];
  } else {
    columns = [
      {
        header: "DATE",
        accessorKey: "Date",
        Cell: ({ row }) =>
          moment(row.original.Date).format("MM/DD/YYYY "),
        size: 100,
      },
      {
        header: "TRANSACTION TYPE",
        accessorKey: "Type",
        size: 170,
      },
      {
        header: "NUM",
        accessorKey: "ID",
        Cell: ({ row }) => {
          return (
            <p
              onClick={() =>
                handleEdit(
                  row.original?.TransactionTypeID,
                  row.original?.ID,
                  row.original?.Type,
                  row.original?.RecSaleID
                )
              }
              className="cursor-pointer"
            >
              {row.original.ID}
            </p>
          );
        },

        size: 100,
      },
      {
        header: "NAME",
        accessorKey: "Name",
        // size: 100,
      },
      {
        header: "MEMO/ DESCRIPTION",
        accessorKey: "Memo",
        // size: 100,
      },
      {
        header: "ACCOUNT",
        accessorKey: "ChartOfAccount",
        // size: 100,
      },
      // {
      //   header: "Cleared",
      //   accessorKey: "ID",
      //   // size: 100,
      // },
      {
        header: "AMOUNT",
        accessorKey: "AmountLine",
        // Cell: ({ row }) => row.original.Deposit > 0 ? row.original.Deposit : row.original.Payment,
        // Cell: ({ row }) => {
        //   if (row.original.Type === "Receive Payment" ) {
        //     return row.original.Deposit;
        //   } else if (row.original.Type === "Expense" || row.original.Type === "Vendor Credit" || row.original.Type === "Bill Payment") {
        //     return row.original.Payment;
        //   } else if ( row.original.Type === "Journal") {
        //     return ''
        //   } else {
        //     return ""; // or some default value
        //   }
        // },
        Cell: ({ row }) => {
          const { Type, Deposit, Payment, TransactionTypeID, ID, RecSaleID } =
            row.original;
          const handleClick = () =>
            handleEdit(TransactionTypeID, ID, Type, RecSaleID);
          let displayValue = "";

          if (Type === "Receive Payment") {
            displayValue = Deposit;
          } else if (
            ["Expense", "Vendor Credit", "Bill Payment"].includes(Type)
          ) {
            displayValue = Payment;
          }

          return (
            <span onClick={handleClick} className="cursor-pointer">
              {displayValue}
            </span>
          );
        },
        size: 120,
      },
      {
        header: "BALANCE",
        accessorKey: "Balance",
        Cell: ({row}) => Number(row.original.Balance).toFixed(2),
        size: 140,
        Footer: () => (
          <Stack>
            <Box>Total: {amount}</Box>
          </Stack>
        ),
      },
      {
        header: "A/P Paid",
        accessorKey: "AP",
        size: 120,
      },
      {
        header: "A/R Paid",
        accessorKey: "AR",
        // Cell: ({ row }) => row.original.PayeeUserType === "Customer" ? row.original.Payee : '',
        size: 120,
      },
      {
        header: "DueDate",
        accessorKey: "DueDate",
        Cell: ({ row }) =>
          row.original.DueDate && row.original.DueDate != "0000-00-00"
            ? moment(row.original.DueDate).format("MM/DD/YYYY ")
            : "",
        size: 100,
      },
      {
        header: "Credit",
        accessorKey: "Deposit",
        size: 120,
      },
      {
        header: "Debit",
        accessorKey: "Payment",
        size: 120,
      },
      // {
      //   header: "Invoiced Date",
      //   accessorKey: "ID",
      //   // size: 100,
      // },
      {
        header: "Last Modified Date Line",
        accessorKey: "CreatedModifiedDate",
        Cell: ({ row }) =>
          row.original.CreatedModifiedDate
            ? moment(row.original.CreatedModifiedDate).format("YYYY-MM-DD")
            : "",
        size: 140,
      },

      {
        header: "PAYEE",
        accessorKey: "Payee",
        Cell: ({ row }) =>
          row.original.PayeeUserType === "Customer"
            ? row.original.Payee + " (Cus)"
            : row.original.PayeeUserType === "Supplier"
            ? row.original.Payee + " (Sup)"
            : row.original.PayeeUserType === "Employee"
            ? row.original.Payee + " (Emp)"
            : "",
        // size: 200,
      },
    ];
  }


  const defaultColDef = {
    sortable: true,
  };

  function calculateBalance(entries) {
    let finalBalance = 0;
    const ArrayVRegister = [];

    entries.forEach((entry, index) => {
      // Update balance based on deposit and payment

      if (entry?.AccountTypeID === 11) {
        finalBalance -= Number(entry?.Deposit);
        finalBalance += Number(entry?.Payment);
      } else {
        finalBalance += Number(entry?.Deposit);
        finalBalance -= Number(entry?.Payment);
      }

      // Store the balance after each entry
      ArrayVRegister.push({
        ...entry,
        entryNumber: index + 1,
        Deposit: entry?.Deposit,
        Payment: entry?.Payment,
        Balance: finalBalance,
      });
    });

    return {
      ArrayVRegister,
      finalBalance,
    };
  }


  const accountId = chartOfAccountDropdown?.some(
    (option) =>
      option.ID == (id == undefined ? 0 : id) &&
      (option.AccountName === "Accounts Receivable (A/R)" ||
        // option.AccountName === "Credit Card" ||
        option.AccountName === "Accounts Payable (A/P)")
  );


  console.log(accountId, "accountId654654")

  const onGridReady = () => {
    setLoading(true);

    

    console.log(beginningDate, finalDate, "datefilter");
    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountviewregister?searchtext=&transactiontype=1&customerid=0&supplierid=0&startdate=${beginningDate}&enddate=${finalDate}&locationid=${locationid}&accountid=${id}&employeeid=0`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        const newarr = res.data.ResponseData?.map((el) => {
          return {
            ...el,
            showDelete: true,
            Payment: el?.Payment ? parseFloat(el?.Payment).toFixed(2) : 0,
            Deposit: el?.Deposit ? parseFloat(el?.Deposit).toFixed(2) : 0,
            showAll: el.Type === "Expense" ? true : false,
          };
        });

        console.log(newarr, "balance data check");
        const FinalData = calculateBalance(newarr);
        console.log(FinalData, "balance data check");

        setResponseData(FinalData?.ArrayVRegister); 

        // if (id == 1 || id == 5) {
          setAmount(Number(FinalData?.finalBalance).toFixed(2));
        // }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const AccountSaveAPI = () => {
    // chart of Account Dropdown for account id
    axios
      .get(`${config.accountingBaseUrl}/chartofaccounts/accountddl`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        // console.log("ChartOfAccountDropdown", res.data.ResponseData);
        setChartOfAccountDropdown(res.data.ResponseData);

        setSelectedAccount(
          res.data?.ResponseData?.find((el) => el.ID == id)?.Name
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    AccountSaveAPI();
    onGridReady();
  }, [
    // onGridReady,
    finalDate,
    beginningDate,
    id,
  ]);

  const handleNewInputChange = (event, fieldName) => {
    console.log(event, fieldName, "186");
    // setAccountID(event?.value ? event?.value : 0);
    if (event?.value) {
      navigate(`/account-report/${event?.value}`);
    }
  };

  console.log(beginningDate, finalDate, "datefilter 1");

  return (
    <>
      <Sidebar />
      <Loader loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Account Drilldown QuickReport</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/accounting">Accounting</Link>
                </li>
                <li className="breadcrumb-item active">
                  {selectedAccount}
                  {/* Account QuickReport */}
                </li>
              </ul>
            </div>
          </div>
          <div className="">
            <div className="">
              <div className="col-lg-12 col-md-6 col-sm-12 d-flex justify-content-between">
                <div className="d-flex gap-2">
                  <div>
                    <div className="col-form-label">Account</div>
                    {/* <div className="col-form-label">Account</div> */}
               <div style={{width:"290px"}} className='col-md-11 z-3'>
               <Select
                    // style={{width:"600px"}}
                      onChange={(event) =>
                        handleNewInputChange(event, "AccountID")
                      }
                      value={accountTypeDropdownOption?.find(
                        (el) => el?.value == id
                      )}
                      options={accountTypeDropdownOption}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      hideSelectedOptions={true}
                      isClearable={false}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      placeholder="Account"
                      id="AccountId"
                      name="AccountId"
                      className="custom-search-select"
                      // isDisabled={
                      //   transactionid == 5 ||
                      //   transactionid == 7 ||
                      //   transactionid == 11
                      // }
                    />
               </div>
                  </div>
                  <div>
                    <div className="col-form-label"> Date </div>

                    <div style={{width:"150px"}}>
                    <Select
                      // defaultValue={quickBookOptions}
                      onChange={(event) => {
                        handleDateFilter(event);
                      }}
                      options={dateOptions}
                      backspaceRemovesValue={false}
                      controlShouldRenderValue={true}
                      isClearable={true}
                      // defaultValue={5}
                      // hideSelectedOptions={true}
                      styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                      value={dateOptions.find((el) => el?.value == customeDate)}
                      className="custom-search-select"
                    />
                    </div>
                  </div>
                  {beginningDate && (
                    <div>
                      <div className="col-form-label">From</div>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="StartDate"
                        name="StartDate"
                        value={beginningDate}
                        // defaultValue={todayDate}
                        onChange={(event) => handleDate(event)}
                      />
                    </div>
                  )}
                  {finalDate && (
                    <div>
                      <div className="col-form-label">To: </div>
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="StartDate"
                        name="StartDate"
                        value={finalDate}
                        // defaultValue={todayDate}
                        onChange={(event) => handleEndDate(event)}
                      />
                    </div>
                  )}
                </div>
                {accountId && (
                  <div className="text-end">
                    <h6 className="p">${amount ? amount : 0}</h6>
                    <p class="p-medium">Balance</p>
                    {/* <p className="text-right p">${amount ? amount : 0}</p> */}
                    {/* <p className="text-right p">${amountforAPandAR}</p> */}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="card mt-5">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  {/* <h2>SonarPos</h2> */}
                  <h6>
                    {selectedAccount}
                    {/* Account QuickReport */}
                  </h6>
                  {/* <div className="row">
                    {/* <p> Date: {new Date().toLocaleDateString()}</p> */}
                  {/* <p>
                      Date: 12 May - 31 Dec
                    </p>
                  </div>  */}
                </div>
              </div>

              {/* <hr /> */}
              {/* ref={tableContainerRef} */}

              {/* <div style={containerStyle}> */}

              <div className="table-responsive">
                <div className="table mt-3">
                  <MaterialReactTable
                    columns={columns}
                    data={descRowsData}
                    // positionPagination='top'
                    enableColumnResizing
                    enableGrouping
                    enableStickyHeader
                    enableStickyFooter
                    // enableRowSelection
                    enableColumnOrdering
                   
                    // enableRowActions={checkUserPermission(PERMISSION_EDIT) || checkUserPermission(PERMISSION_DELETE) || checkUserPermission("/Delivery-Status") || checkUserPermission(PERMISSION_RECEIPT)}
                    positionGlobalFilter="left"
                   
                    muiTableContainerProps={{
                      sx: { maxHeight: "fit-content" },
                    }}
                    muiPaginationProps={{
                      rowsPerPageOptions: [25, 50, 100, 300],
                    }}
                    // enableHiding={id != 1 || id != 5}
                    initialState={{
                      density: "comfortable",
                      showGlobalFilter: true,
                      expanded: true, //expand all groups by default
                      // grouping: [""], //an array of columns to group by by default (can be multiple)
                      pagination: { pageIndex: 0, pageSize: 25 },
                      // sorting: { id: "Name", desc: false }, //sort by state by default
                      columnVisibility: {
                        AP: false,
                        AR: false,
                        Deposit: true,
                        Payment: true,
                        CreatedModifiedDate: false,
                        Payee: true,
                        Date: true,
                        Type: true,
                        ID: true,
                        Name: true,
                        Memo: true,
                        ChartOfAccount: true,
                        AmountLine: true,
                        Balance: true,
                        DueDate: true,
                      },
                    }}

                    muiTableBodyRowProps={({ row }) => ({
                      //implement row selection click events manually
                      onClick: () => handleEdit(row.original.TransactionTypeID, row.original.ID, row.original.Type, row.original.RecSaleID),
                      // selected: rowSelection[row.id],
                      sx: {
                        cursor: 'pointer',
                      },
                    })}
                    //For color of each alternative row(Zebra-column)
                    muiTableBodyProps={{
                      sx: () => ({
                        "& tr:nth-of-type(even)": {
                          backgroundColor:
                            "var(--datatable-row-background-color)",
                          //'rgb(237 237 233 / 63%)'
                        },
                        "& td": {
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        },

                        "& tr": {
                          lineHeight: "16px",
                          fontWeight: "400",
                          fontSize: "12px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        },
                      }),
                    }}
                    // For providing color to header of table
                    muiTableHeadCellProps={{
                      sx: (theme) => ({
                        background: "var(--datatable-row-background-color)", //'#e9e9e9',
                        borderRight:
                          "1px solid var(--datatable-row-background-hover-color)",
                        lineHeight: "16px",
                        fontWeight: "500",
                        fontSize: "14px",
                        color: "var(--primary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    muiSelectCheckboxProps={{
                      sx: (theme) => ({
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--prinary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    muiSelectAllCheckboxProps={{
                      sx: (theme) => ({
                        lineHeight: "16px",
                        fontWeight: "400",
                        fontSize: "12px",
                        color: "var(--prinary-color-800)",
                        fontFamily: "Inter",
                      }),
                    }}
                    condit
                  
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
